import React, { useEffect, useRef } from "react";
import lottie from "lottie-web";
const DocumentVerified = () => {
  const container = useRef(null);

  useEffect(() => {
    lottie.loadAnimation({
      container: container.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: require("../../utils/lottie/document_Verified.json"),
    });
  }, []);
  return (
    <div>
      <div
        className="lottieContainer"
        ref={container}
        style={{
          width: "200px",
          height: "200px",
          position: "relative",
        }}
      >
        <img src="/assets/stars.svg" alt="stars" className={`stars lottieBg`} />
        <img
          src="/assets/pinkCircle.svg"
          alt="circle"
          className={`circle lottieBg`}
        />
      </div>
    </div>
  );
};

export default DocumentVerified;
